module.exports = __webpack_public_path__ + "static/media/rem-galleu.7f40da4f.png";